import React from 'react';

import classNames from 'classnames';

interface CardProps {
    children: React.ReactNode;
    title?: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    footer?: React.ReactNode;
    padding?: 'none' | 'sm' | 'md' | 'lg';
    interactive?: boolean;
    className?: string;
    onClick?: () => void;
}

const paddingClasses = {
    none: '',
    sm: 'p-3 sm:p-4',
    md: 'p-4 sm:p-5',
    lg: 'p-5 sm:p-6',
};

const Card: React.FC<CardProps> = ({ children, title, description, actions, footer, padding = 'md', interactive = false, className, onClick }) => {
    const hasHeader = title || description || actions;

    return (
        <div
            onClick={onClick}
            className={classNames(
                'bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl',
                {
                    'transition-all duration-150 hover:border-slate-300 dark:hover:border-slate-700 hover:shadow-sm cursor-pointer':
                        interactive || onClick,
                },
                className,
            )}
        >
            {hasHeader && (
                <div className="flex flex-wrap items-start justify-between gap-3 px-4 sm:px-5 py-3.5 border-b border-slate-100 dark:border-slate-800">
                    <div className="min-w-0">
                        {title && <h3 className="text-sm font-semibold text-slate-900 dark:text-white">{title}</h3>}
                        {description && <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">{description}</p>}
                    </div>
                    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
                </div>
            )}
            <div className={paddingClasses[padding]}>{children}</div>
            {footer && (
                <div className="px-4 sm:px-5 py-3 border-t border-slate-100 dark:border-slate-800 bg-slate-50/60 dark:bg-slate-800/40 rounded-b-xl">
                    {footer}
                </div>
            )}
        </div>
    );
};

export default Card;
